<template lang="pug">
ul.documents-list(color="transparent")
  li.documents-list__item(
    v-for="document in documents"
    :key="document.id"
  )
    a.documents-list__link(
      target="_blank"
      :href="document.url"
    )
      v-icon(
        color="redesignYellowDarken"
        :size="56"
      ) $ifile-outline
      span.documents-list__name {{ document.name ? document.name : document['original_name'] }}
</template>

<script>
export default {
  name: 'RedesignDocumentsList',
  props: {
    documents: { type: Array, default: () => [] },
  },
};
</script>

<style lang="scss" scoped>
.documents-list {
  display: flex;
  flex-wrap: wrap;
  gap: 36px;
  padding: 0;
  list-style: none;

  &__item {
    max-width: 330px;
  }

  &__link {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__name {
    display: -moz-box;
    display: -webkit-box;
    color: #{$redesignBlack};
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    -moz-box-orient: vertical;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-clamp: 3;
    box-orient: vertical;
  }
}
</style>
